/* Project Import will be here */
import { post, IRequest } from "./index";
import { IHashGenerationParams } from "models/paymentModels";
/* Project Import will be here */

/* Get unpaid invoice list and information */
export const getUnpaidInvoiceListApi = () => {
    const request: IRequest = {
        subUrl: `/Collection/PendingBills`
    };

    return post(request);
};

/* Get paid invoice list and information */
export const getPaidInvoiceListApi = () => {
    const request: IRequest = {
        subUrl: `/Collection/PaidBills`
    };

    return post(request);
};

/* Generate hash key and initiate the payment process */
export const generateHashKeyApi = (data: IHashGenerationParams) => {
    const request: IRequest = {
        subUrl: `/Collection/GenerateHash`,
        data
      };
      return post(request);
}